import { createStore } from 'vuex'; // Importar createStore de Vuex

export default createStore({
  state: {
    resultado: null,   // Aquí guardaremos el resultado del maridaje
    ingredientes: null,  // Aquí guardaremos los ingredientes seleccionados
    quesos: [
      { id: 'Maasdam', nombre: 'Maasdam', descripcion: 'Un queso agradable al paladar con notas de nuez, de textura suave y cremosa que se vuelve un favorito por su versatilidad.', imagen: 'Maasdam-260g.png' },
      { id: 'Procesado-ahumado-natural', nombre: 'Ahumado', descripcion: 'Un queso fundido con sabor ahumado, elaborado en madera de haya.', imagen: 'Procesado-ahumado-natural-250g.png' },
      { id: 'Edam', nombre: 'Edam', descripcion: 'Un queso suave, ligeramente salado con aroma poco acentuado, ideal para cualquier ocasión.', imagen: 'Queso-Edam-Baby-Bola.png' },
      { id: 'Procesado-ahumado-finas-hierbas', nombre: 'Ahumado finas hierbas', descripcion: 'Queso ahumado con finas hierbas, que aporta un sabor exquisito a tus platillos.', imagen: 'Procesado-ahumado-hierbas-200g.png' },
      { id: 'Gouda', nombre: 'Gouda', descripcion: 'Un queso de sabor suave y cremoso, ideal para aperitivos y ensaladas, hecho 100% de leche de vaca.', imagen: 'Quedo-Gouda-Bloque-400g.png' },
    ],
    ingredientesDisponibles: {
      crujiente: [
        { id: 'almendras', nombre: 'Almendras', descripcion: 'Almendras crujientes', imagen: 'Almendras.png' },
        { id: 'avellanas', nombre: 'Crujientes Avellanas', descripcion: 'Avellanas crujientes', imagen: 'Avellanas.png' },
        { id: 'nuez-pecana', nombre: 'Nueces Pecanas', descripcion: 'Nuez pecana', imagen: 'Nuez-pecana.png' },
        { id: 'nuez-india', nombre: 'Nueces de la India', descripcion: 'Nuez de la India', imagen: 'Nuez-de-la-india.png' },
        { id: 'pistaches', nombre: 'Pistaches', descripcion: 'Pistaches.', imagen: 'Pistaches.png' },
      ],
      panesGalletas: [
        { id: 'baguette', nombre: 'Baguette', descripcion: 'Baguette fresca.', imagen: 'Baguette.png' },
        { id: 'galletas-saladas', nombre: 'Galletas saladas', descripcion: 'Galletas saladas', imagen: 'Galletas-saladas.png' },
        { id: 'pan-centeno', nombre: 'Pan de Centeno', descripcion: 'Pan de centeno', imagen: 'Pan-de-centeno.png' },
        { id: 'palitos-pan', nombre: 'Palitos de pan', descripcion: 'Palitos de pan', imagen: 'Palitos-de-pan.png' },
        { id: 'pretzels', nombre: 'Pretzels', descripcion: 'Pretzels.', imagen: 'Pretzels.png' },
      ],
      dulce: [
        { id: 'fresas', nombre: 'Fresas', descripcion: 'Fresas frescas.', imagen: 'Fresas.png' },
        { id: 'manzana', nombre: 'Manzana', descripcion: 'Manzana.', imagen: 'Manzana.png' },
        { id: 'moras-azules', nombre: 'Moras azules', descripcion: 'Moras azules.', imagen: 'Moras-azules.png' },
        { id: 'uvas-verdes', nombre: 'Uvas verdes', descripcion: 'Uvas verdes.', imagen: 'Uvas-verdes.png' },
        { id: 'higos', nombre: 'Higos', descripcion: 'Higos', imagen: 'Higos.png' },
      ],
      vegetal: [
        { id: 'pepinos', nombre: 'Pepinillos', descripcion: 'Pepinillos', imagen: 'Pepinillos.png' },
        { id: 'aceitunas', nombre: 'Aceitunas verdes', descripcion: 'Aceitunas verdes frescas', imagen: 'Aceitunas.png' },
        { id: 'pimiento', nombre: 'Pimiento rojo', descripcion: 'Pimiento rojo', imagen: 'Pimiento.png' },
        { id: 'zanahorias', nombre: 'Zanahoria en tiras', descripcion: 'Zanahorias cortadas en tiras', imagen: 'Zanahorias-en-palitos.png' },
        { id: 'tomates-cherry', nombre: 'Tomatitos', descripcion: 'Tomates cherry', imagen: 'Tomates-cherry.png' },
      ],
      charcuteria: [
        { id: 'mortadela', nombre: 'Mortadela', descripcion: 'Mortadela', imagen: 'Mortadela.png' },
        { id: 'jamon-serrano', nombre: 'Jamón Serrano', descripcion: 'Jamón serrano', imagen: 'Jamon-serrano.png' },
        { id: 'fuet', nombre: 'Fuet', descripcion: 'Fuet español', imagen: 'Fuet.png' },
        { id: 'cuadritos-jamon', nombre: 'Jamón en cubitos', descripcion: 'Cuadritos de jamón', imagen: 'Cuadritos-de-jamon.png' },
        { id: 'salami', nombre: 'Salami', descripcion: 'Salami', imagen: 'Salami.png' },
      ],
      bebida: [
        { id: 'tequila', nombre: 'Tequila', descripcion: 'Vasito con tequila', imagen: 'Vasito-con-tequila.png' },
        { id: 'vino-tinto', nombre: 'Vino Tinto', descripcion: 'Vino tinto en copa', imagen: 'Vino-tinto-en-copa.png' },
        { id: 'vino-blanco', nombre: 'Vino Blanco', descripcion: 'Vino blanco en copa', imagen: 'Vino-blanco-en-copa.png' },
        { id: 'agua', nombre: 'Agua Mineral Infusionada', descripcion: 'Vaso con agua mineral', imagen: 'Vaso-con-agua-mineral-infusionada.png' },
        { id: 'cerveza', nombre: 'Cerveza', descripcion: 'Tarro con cerveza', imagen: 'Tarro-con-cerveza.png' },
      ]
    }
  },
  mutations: {
    setResultado(state, resultado) {
      state.resultado = resultado;
    },
    setIngredientes(state, ingredientes) {
      state.ingredientes = ingredientes;
    },
    resetDatos(state) {
      state.resultado = null;
      state.ingredientes = null;
    }
  },
  actions: {
    actualizarResultado({ commit }, resultado) {
      commit('setResultado', resultado);
    },
    actualizarIngredientes({ commit }, ingredientes) {
      commit('setIngredientes', ingredientes);
    },
    limpiarDatos({ commit }) {
      commit('resetDatos');
    }
  },
  getters: {
    resultado: state => state.resultado,
    ingredientes: state => state.ingredientes,
    quesos: state => state.quesos,
    ingredientesDisponibles: state => state.ingredientesDisponibles
  }
});
